// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"postdraft_menuIcon__2aej7","menuIcon2":"postdraft_menuIcon2__1akIM"};